import { z } from 'zod';
import { avatarUrlSchema, nameSchema, stringifiedDateSchema } from '@/utils/schemas';

export const friendApplicationScheme = z.object({
  ID: z.number(),
  UserID: z.number(),
  UserNickName: nameSchema,
  UserHeadImg: avatarUrlSchema,
  Status: z.union([z.literal(0), z.literal(1), z.literal(2)]).default(0),
  Remark: z.string(),
  TargetUserID: z.number(),
  TargetUserNickName: nameSchema,
  CreateTime: stringifiedDateSchema,
});

export type FriendApplication = z.infer<typeof friendApplicationScheme>;
